import React from 'react';
import { Link } from 'react-router-dom';
import Username from '../common/Username';

const QuotesItem = (props) => (
    <div className="panel-adt">
        <Link to={"/quotes/"+props.quote.slug}>
            <h2>{props.quote.title}</h2>
        </Link>
        <blockquote style={{marginBottom:0}}>
            <p style={{whiteSpace:'pre-wrap'}}>{props.quote.body}</p>
            <small>
                { props.quote.involved.length > 0 ? props.quote.involved.map((member) => (
                    <span key={`${member}-quotedmember`}>
                        <Username user={props.users[member]}
                              rank={props.ranks[props.users[member].rank]} placement="left"/>
                        <span> </span>
                    </span>
                    )) : null
                }
            </small>
        </blockquote>
    </div>
);


export default QuotesItem;


// WEBPACK FOOTER //
// ./src/Media/QuotesItem.js